// extracted by mini-css-extract-plugin
export default {"channel":"ChannelCard_channel__rVNzC","channel__top":"ChannelCard_channel__top__vbumz","channel__footer":"ChannelCard_channel__footer__717zF","play":"ChannelCard_play__C2RyW"};